import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@ant-design/v5-patch-for-react-19";
import "./index.css";
import { ContextProvider } from "./context/ContextProvider";
import { RouterProvider } from "react-router-dom";
import router from "./router/router.jsx";
import * as Sentry from "@sentry/react";
import {
  VITE_SENTRY_DSN,
  VITE_SENTRY_ENV,
  VITE_SENTRY_RELEASE,
  VITE_SENTRY_REPLAY_RATE,
  VITE_SENTRY_TRACES_RATE,
} from "./config.js";

Sentry.init({
  dsn: VITE_SENTRY_DSN || import.meta?.env?.VITE_SENTRY_DSN || "",

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      colorScheme: "light",
      showBranding: false,
      triggerLabel: "Report a bug",
      formTitle: "Tell us what went wrong",
      messagePlaceholder: "What happened? What did you expect?",
      successMessageText: "Thanks! We’ll look into this.",
      useSentryUser: { name: "fullName", email: "email" },
      enableScreenshot: true,
    }),
  ],

  environment: VITE_SENTRY_ENV || import.meta?.env?.VITE_SENTRY_ENV,

  release: VITE_SENTRY_RELEASE || import.meta?.env?.VITE_SENTRY_RELEASE,

  // Privacy: set to true only if approved
  sendDefaultPii: true,

  // Performance / tracing
  tracesSampleRate:
    VITE_SENTRY_TRACES_RATE || import.meta?.env?.VITE_SENTRY_TRACES_RATE,

  tracePropagationTargets: [
    "localhost",
    /^https:\/\/uvcf\.devops\.renu\.ac\.ug(\/|$)/,
    /^https:\/\/uvcf-api\.devops\.renu\.ac\.ug(\/|$)/,
  ],
  // Optional: link CPU profiles to traces
  // profilesSampleRate: Number(import.meta.env.VITE_SENTRY_PROFILES_RATE || 0),

  // Session Replay
  replaysSessionSampleRate:
    VITE_SENTRY_REPLAY_RATE || import.meta?.env?.VITE_SENTRY_REPLAY_RATE,

  replaysOnErrorSampleRate: 1.0,

  // Optional: proxy browser traffic through your app to avoid adblock/CORS
  // tunnel: "/sentry",
  // allowUrls: [/^https:\/\/uvcf\.devops\.renu\.ac\.ug/, /^https:\/\/uvcf-api\.devops\.renu\.ac\.ug/],
  // denyUrls: [/^chrome-extension:\/\//],
});

createRoot(document.getElementById("root"), {
  onUncaughtError: Sentry.reactErrorHandler((error, info) => {
    // You keep dev logs + still capture with Sentry
    console.warn("Uncaught error", error, info?.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  // <StrictMode>
  <ContextProvider>
    <RouterProvider router={router} />
  </ContextProvider>
  // </StrictMode>
);
